import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import apple from '../../assets/images/apple.png';
import tree from '../../assets/images/tree_1.png';
import treeLeaves from '../../assets/images/tree_2.png';

const StyledTree = styled.div`
	position: absolute;
	left: 50%;
	bottom: 0px;
	transform: translateX(-50%);
	width: 1359px;
	height: 1080px;
	background-image: url(${tree});
	background-repeat: no-repeat;
	background-size: contain;
`;

const StyledTreeLeaves = styled.div`
	position: absolute;
	left: 50%;
	bottom: 0px;
	z-index: 10;
	transform: translateX(-50%);
	width: 900px;
	height: 900px;
	background-image: url(${treeLeaves});
	background-repeat: no-repeat;
	background-size: contain;
	pointer-events: none;
`;

const StyledApplesContainer = styled.div`
	position: absolute;
	left: 50%;
	bottom: 0;
	transform: translateX(-50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 40px;
`;

const StyledBottomShadow = styled.div`
	position: absolute;
	width: 100%;
	height: 400px;
	bottom: 0;
	z-index: 11;
	background: linear-gradient(360deg, #111314 0%, rgba(17, 19, 20, 0) 100%);
	opacity: 0.8;
	pointer-events: none;
`;

const StyledAppleRow = styled.div`
	display: flex;
	align-items: center;
	gap: 40px;
`;

const StyledAppleWrapper = styled.div<{ $isAnimating?: boolean }>`
	position: absolute;
	width: 60px;
	height: 60px;
	transition:
		transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
		opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),
		filter 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	transform: ${(props) =>
		props.$isAnimating ? 'translateY(-10px) scale(1.05)' : 'none'};
	opacity: ${(props) => (props.$isAnimating ? 0 : 1)};
	filter: ${(props) => (props.$isAnimating ? 'brightness(1.1)' : 'none')};
`;

const StyledApple = styled.div`
	width: 100%;
	height: 100%;
	background-image: url(${apple});
	background-repeat: no-repeat;
	background-size: contain;
	transform-origin: center center;
`;

const StyledTopContainer = styled.div`
	position: absolute;
	left: 50%;
	top: 80px;
	transform: translateX(-50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
`;

const StyledTimerContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 30px;
	padding: 0 8px;
	border-radius: 10px;
	background-color: #ffffff;

	${Text} {
		width: 40px;
		font-weight: 700;
		font-size: 14px;
		color: #262628;
	}

	img {
		width: 16px;
		height: 16px;
		user-select: none;
		pointer-events: none;
		filter: invert(100%);
	}
`;

export {
	StyledApple,
	StyledAppleRow,
	StyledApplesContainer,
	StyledAppleWrapper,
	StyledBottomShadow,
	StyledTimerContainer,
	StyledTopContainer,
	StyledTree,
	StyledTreeLeaves,
};
